export default {
      id: "nav_gauche-usage",
      viewBox: "0 0 40 40",
      url: "../dist/images/" + "sprite.svg#nav_gauche-usage",
      toString: function () {
        return this.url;
      }
    }